import gql from 'graphql-tag'

/**
 * 查询用户资产总览
 */

export const queryFundAssetAllInfo = gql`
  query FundAssetAllInfoAndEnquireCurrency ($filter: EnquireAssetAllInput!) {
    FundAssetAllInfo: FundAssetAllInfo(filter: $filter) {
      ok
      reason {
        err
        desc
      }
      data {
        clientId
        fundAccount
        assetHkd
        assetHkdDispaly
        childs {
          type
          assetHkd
          assetHkdRate
          assetHkdDispaly
          assetHkdRateDispaly
        }
      }
    }
    EnquireCurrency: EnquireCurrency {
      ok
      reason {
        err
        desc
      }
      data {
        ccy
        baseCcy
        rate
      }
    } 
  }
`
// 查询用户资产总览和股票持仓
export const queryFundAccMarketListAndStockPosPageList = gql`
  query stockDataList ($stockPage: FilterGetStockPosPageListInput!, $fundAcc: FilterFundAccMarketListInput) {
    stockPosPageList: StockPosPageList(filter: $stockPage) {
      data {
        rows {
          exchangeType
          stockCode
          stockNameGb
          clientId
          fundAccount
          moneyType
          stockType
          incomeBalanceDisplay
          enableAmountDisplay
          enableAmount
          stockName
          marketValueDisplay
          currentPriceDisplay
          incomePercentDisplay
          costPriceDisplay
          currentAmountDisplay
        }
      }
      ok
      reason {
        err
        desc
      }
    } 
    fundAccMarketList: FundAccMarketList(filter: $fundAcc) {
      data {
        fundAccount
        moneyType
        exchangeType
        marketValueDisplay
        fetchBalanceDisplay
        frozenBalanceDisplay
        enableBalanceDisplay
      }
      ok
      reason {
        err
        desc
      }
    } 
  }
`

// 查询其他持仓
export const queryOtherPosPageList = gql`
  query queryOtherPosPageList ($filter: FilterGetStockPosPageListInput!) {
    otherPosPageList: OtherPosPageList (filter: $filter) {
      data {
        mv {
          ccy
          value
        } 
        statisInfo {
          exchangeType
          ccy
          mv
          incomeAcc
          incomeBalance
          holdCash
        } 
        rows {
          moneyType
          stockCode
          stockNameGb
          marketValueDisplay
          exchangeType
          stockCode
          underlying
          marketValueDisplay
          maturity_date
          currentAmount
          maturity_days
          yield_to_maturity
        }
      }
      ok
      reason {
        err
        desc
      }
    } 
  }
`
// 查询结构化票据持仓
export const querySpsPageList = gql`
  query querySpsPageList ($stockPos: FilterGetStockPosPageListInput!, $lifecycle: GetClientLifecycleInput!) {
    otherPosPageList: OtherPosPageList (filter: $stockPos) {
      data {
        rows {
          exchangeType
          stockCode
          marketValueDisplay
          investment_amount
          underlying
          issuer
          maturity_date
          sub_type
          moneyType
          yield_to_maturity
        }
        totalMv {
          ccy
          value
        } 
      }
      ok
      reason {
        err
        desc
      }
    }
    clientLifecycle: getClientLifecycle (filter: $lifecycle) {
      ok
      data {
        lifecycles {
          couponRatio
          lifecycleId
          productType
          isin
          size
          underlyingPerformance {
            code
            performance
          } 
        }
      }
      reason {
        err
        desc
      }
    } 
  }
`
